import { User } from '@features/users/models/user.model';
import { CompanyLabelType } from '@shared-features/enums/shared-enums.enum';
import { ShipmentCreationTemplateTypes } from '@shared-features/enums/shipments.enum';


/** YCC customers may never create bulk shipments. */
export function isYccCustomer(user: User): boolean {
  return (
    user?.customerLabel === CompanyLabelType.Ycc || user?.customerLabel === CompanyLabelType.YccCustomer
  );
}

/**
 * The basic template is a prerequisite, not one option among several: every bulk row is submitted as
 * a basic shipment (`creationTemplateType: Basic`). Any other template alongside it is fine; a
 * customer without it - bidding-only, say - cannot use the page at all.
 */
export function hasBasicTemplate(user: User): boolean {
  return !!user?.creationTemplates?.some((template) => template.type === ShipmentCreationTemplateTypes.Basic);
}

export function canCreateBulkShipments(user: User): boolean {
  return hasBasicTemplate(user) && !isYccCustomer(user);
}

export function isBulkShipmentsVisible(user: User): boolean {
  return hasBasicTemplate(user);
}
